/** Me — the driver's own pages (IA §2 "Me", phone-first). Subjects come from the token (RULES §API-2). */
import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { appRoute } from '@/app/appRoute';

export const meIndexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/me',
  beforeLoad: () => {
    throw redirect({ to: '/me/today' });
  },
});

export const meTodayRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/me/today',
  component: lazyRouteComponent(() => import('./pages/MyDayPage')),
});

export const meTripsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/me/trips',
  staticData: { permission: 'trips.trip.read' },
  validateSearch: (s: Record<string, unknown>): { days?: 1 | 7 | 30 } => ({
    days: [1, 7, 30].includes(Number(s.days)) ? (Number(s.days) as 1 | 7 | 30) : undefined,
  }),
  component: lazyRouteComponent(() => import('./pages/MyTripsPage')),
});

export const meScoresRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/me/scores',
  staticData: { permission: 'insights.driver.read' },
  validateSearch: (s: Record<string, unknown>): { days?: 7 | 30 | 90 } => ({
    days: [7, 30, 90].includes(Number(s.days)) ? (Number(s.days) as 7 | 30 | 90) : undefined,
  }),
  component: lazyRouteComponent(() => import('./pages/MyScoresPage')),
});

export const meCoachingRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/me/coaching',
  staticData: { permission: 'coaching.session.read' },
  component: lazyRouteComponent(() => import('./pages/MyCoachingPage')),
});

export const meMessagesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/me/messages',
  component: lazyRouteComponent(() => import('./pages/MyMessagesPage')),
});

export const meConversationRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/me/messages/$conversationId',
  component: lazyRouteComponent(() => import('./pages/MyConversationPage')),
});

export const meHoursRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/me/hours',
  staticData: { permission: 'tacho.activity.read' },
  component: lazyRouteComponent(() => import('./pages/MyHoursPage')),
});

/** How I am notified (R-28): any signed-in person, their own preferences (personal permission). */
export const meNotificationsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/me/notifications',
  staticData: { permission: 'comms.preference.manage' },
  component: lazyRouteComponent(() => import('./pages/NotificationsPage')),
});

/** Change my password: any signed-in person, their own account (POST /api/me/password reads the principal). */
export const mePasswordRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/me/password',
  component: lazyRouteComponent(() => import('./pages/PasswordPage')),
});
